import { React, useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ children, role, ...rest }) => {
  const isAuthenticated = localStorage.getItem('jwt');

  const [redirectHome, setRedirectHome] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    if (role === 'admin' && userRole !== 'admin') {
      setRedirectHome(true);
    } else if (role === 'supplier' && (userRole !== 'admin' &&  userRole !== 'supplier')) {
      setRedirectHome(true);
    }
  }, []);

  return (
    <>
      <Route
        {...rest}
        render={({ location }) =>
          isAuthenticated ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: '/signPage',
                state: { from: location },
              }}
            />
          )
        }
      />
      {redirectHome && 
        <Redirect to={{
          pathname: '/',
        }}/>
      }
    </>
  );
};

export default PrivateRoute;
